import { useEffect } from 'react';
import { useEditorStore } from '../editor-store';
import { isBackspace, isCmdC, isCmdD, isCmdShiftZ, isCmdX, isCmdZ } from './keyboard';
import { useCreateBlockActions } from './create-block-actions.hook';
import { useClipboardActions } from './clipboard-actions.hook';
import { isReadonly } from '../native-e-signature/utils';

export const useEditorKeydownHook = () => {
  const selectedBlockId = useEditorStore((state) => state.selectedBlockId);
  const clearSelectedBlock = useEditorStore((state) => state.clearSelectedBlock);
  const editorContentElement = useEditorStore((state) => state.editorContentElement);

  const undo = useEditorStore((state) => state.undo);
  const redo = useEditorStore((state) => state.redo);

  const sections = useEditorStore((state) => state.layout.sections);
  const readonly = isReadonly(sections);

  const { cutBlockByBlockId, copyBlockByBlockId } = useClipboardActions();
  const { appendBlockByBoundary, duplicateBlock, deleteBlock } = useCreateBlockActions();

  useEffect(() => {
    const listener = function (event: KeyboardEvent) {
      console.log('keydown', event);
      if (!readonly) {
        if (event.key === 'Escape') {
          event.preventDefault();
          clearSelectedBlock();
        } else if (isCmdZ(event)) {
          event.preventDefault();
          undo();
        } else if (isCmdShiftZ(event)) {
          event.preventDefault();
          redo();
        }
      }
    };
    document.addEventListener('keydown', listener);
    return () => {
      document.removeEventListener('keydown', listener);
    };
  }, [readonly]);

  useEffect(() => {
    const listener = async (event: KeyboardEvent) => {
      if (!readonly && selectedBlockId) {
        if (isCmdD(event)) {
          event.preventDefault();
          duplicateBlock(selectedBlockId);
        } else {
          const isCopyEvent = isCmdC(event);
          const isCutEvent = isCmdX(event);
          const isBackspaceEvent = isBackspace(event);
          if (isCopyEvent || isCutEvent || isBackspaceEvent) {
            const currentTarget = event.target as HTMLElement;
            if (currentTarget) {
              if (currentTarget.getAttribute('contenteditable') === 'true' || currentTarget.nodeName === 'INPUT') {
                return;
              }
            }
            if (editorContentElement && !editorContentElement.contains(currentTarget)) {
              return;
            }
            event.preventDefault();
            if (isCopyEvent) {
              await copyBlockByBlockId(selectedBlockId);
            } else if (isCutEvent) {
              await cutBlockByBlockId(selectedBlockId);
            } else if (isBackspaceEvent) {
              deleteBlock(selectedBlockId);
            }
          }
        }
      }
    };

    document.addEventListener('keydown', listener);
    return () => {
      document.removeEventListener('keydown', listener);
    };
  }, [appendBlockByBoundary, selectedBlockId, readonly, editorContentElement]);
};
